import React from 'react';
import { Routes, useLocation } from 'react-router-dom';
import Loader from '../menu/loader';

const PosedRouter = ({ children }) => {
  const location = useLocation();

  return (
    <div id='routerhang'>
      <div key={location.key}>
        <Loader />
        <Routes>
          {children}
        </Routes>
      </div>
    </div>
  );
};

export default PosedRouter;
